import { Page, PageHeader } from "../components/ui";
import EditUser from "../components/sidekick/users/EditUser";

function UserDetails() {
  return (
    <Page>
      <PageHeader
        back={{ to: "/admin/users", label: "Users" }}
        title="Edit User"
      />
      <EditUser />
    </Page>
  );
}

export default UserDetails;
